import { gql } from '@apollo/client';
import { ProductInfoPublic } from '../fragments';

export default gql`
  query product($id: ID) {
    product(id: $id) {
      ...ProductInfoPublic
    }
  }
  ${ProductInfoPublic}
`;
